"use client"

import CommonTitle from "@/ui/common/bit/CommonTitle"
import styled from "@emotion/styled"
import { mediaQueries, sizes } from "ui/theme/theme"
import BlockWrapper from "../../common/BlockWrapper"

export const StyledBlockWrapper = styled(BlockWrapper)`
  ${mediaQueries.desktopM} {
    padding-top: 60px;
  }
  ${mediaQueries.desktopXl} {
    padding-top: 90px;
  }
`

export const StyledSecondCommonTitle = styled(CommonTitle)`
  margin-bottom: 0;
  ${mediaQueries.mobile} {
    margin-bottom: 19px;
  }
  ${mediaQueries.desktopM} {
    margin-bottom: 0;
  }
  ${mediaQueries.desktopXl} {
    margin-bottom: ${sizes.baseQuadric};
  }
`
